<template>
    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#F5F5F6" />
        <path
            d="M7.60178 10.2699H5.63042C5.28212 10.2699 5 10.552 5 10.9003V14.1708C5 14.5191 5.28212 14.8012 5.63042 14.8012H7.86996C8.04759 14.8012 8.22523 14.8256 8.3959 14.8778L12.558 17.699C12.9621 17.8175 13.3626 17.5145 13.3626 17.0965V7.98156C13.3626 7.56012 12.9586 7.2606 12.558 7.37902L8.65363 10.1271C8.30882 10.2176 7.95356 10.2699 7.60178 10.2699Z"
            stroke="black"
            stroke-miterlimit="10" />
        <path
            d="M16.821 8.97072C18.2351 9.53845 19.2347 10.9177 19.2347 12.5338C19.2347 14.1534 18.2281 15.5361 16.8105 16.1004"
            stroke="black"
            stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M15.3379 14.9127C16.2853 14.5365 16.954 13.6135 16.954 12.5338C16.954 11.4576 16.2887 10.5381 15.3449 10.1584"
            stroke="black"
            stroke-miterlimit="10"
            stroke-linecap="round" />
    </svg>
</template>
